import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DimensionActions from './dimension.actions';
import { MetricDimensionClientService } from '@mode/shared/data-access-webapp';
import { AccountFacade } from '@mode/accounts/contract';

@Injectable()
export class DimensionEffects {
  loadDimensions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DimensionActions.metricRouteLoadDimensions),
      withLatestFrom(this.accountFacade.currentOrg$),
      concatMap(([action, org]) => {
        return this.dimensionClient.getDimensions(org.username, action.metricToken);
      }),
      map((dimensions) => DimensionActions.metricRouteLoadDimensionsSuccess({ dimensions })),
      catchError((error) => of(DimensionActions.metricRouteLoadDimensionsFailure({ error })))
    );
  });

  constructor(
    private actions$: Actions,
    public accountFacade: AccountFacade,
    private dimensionClient: MetricDimensionClientService
  ) {}
}
